import styled from 'styled-components';
import ResetSolid from '@simplywallst/ui-core/icons/ResetSolid';
import SearchSolid from '@simplywallst/ui-core/icons/SearchSolid';

export const SearchIcon = styled(SearchSolid)`
  > path {
    fill: ${({ theme }) => theme.color.brand01};
  }
`;

export const ResetIcon = styled(ResetSolid)`
  opacity: 0.5;
  > path {
    fill: ${({ theme }) => theme.color.white};
  }
`;
